module.exports = window;


//////////////////
// WEBPACK FOOTER
// external "window"
// module id = 97
// module chunks = 0 1